import React from 'react'

const ActiveItemDivider = () => {
  return (
    <div className="card-details__divider"></div>
  )
}

export default ActiveItemDivider;
